import React from 'react';

const Loader = ({ align = 'center', className = '', size = 'default', visible, ...props }) => {
    return (React.createElement("span", { className: [
            'pointer-events-none transition-opacity absolute transform -translate-y-1/2',
            align === 'center' ? 'inset-1/2 -translate-x-1/2' : 'top-1/2 ',
            size === 'small' ? 'h-3 w-3' : 'h-5 w-5',
            visible ? '' : 'opacity-0',
            className,
        ].join(' '), "aria-hidden": !visible, ...props },
        React.createElement("div", { className: "lds-ring" },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
};

export { Loader };
//# sourceMappingURL=Loader.js.map
